"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Bot, Database, Eye, Layers, Network, PenLine, PieChart, PlusCircle, Share2, Trash2, Users, Workflow } from "lucide-react";
import { defaultEntityPermissions } from "@/components/settings/PermissionsList";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { WORKSPACE_PERMISSION_RESOURCE_LABELS } from "@/lib/constants/workspace-permission-resources";
import { cn } from "@/lib/utils";
import type { PermissionItem } from "@/types/permissions";
const permissionIcons = {
  aiAssistant: <Bot className="size-4" />,
  automation: <Workflow className="size-4" />,
  dashboards: <PieChart className="size-4" />,
  dataProvider: <Database className="size-4" />,
  users: <Users className="size-4" />,
  viewSharing: <Share2 className="size-4" />,
  workflow: <Network className="size-4" />,
  workspace: <Layers className="size-4" />
};
interface PermissionsSectionProps {
  permissions: PermissionItem[];
  onPermissionChange: (index: number, updatedPermission: PermissionItem) => void;
  className?: string;
  defaultOpen?: boolean;
  id?: string;
  resourceLabels?: Record<string, string>;
}
function PermissionControl(t0) {
  const $ = _c(9);
  const {
    permissions,
    onPermissionChange,
    resourceLabels: t1
  } = t0;
  const resourceLabels = t1 === undefined ? WORKSPACE_PERMISSION_RESOURCE_LABELS : t1;
  let t2;
  if ($[0] !== onPermissionChange || $[1] !== permissions || $[2] !== resourceLabels) {
    let t3;
    if ($[4] !== onPermissionChange || $[5] !== resourceLabels) {
      t3 = (permission, index) => {
        const activeCount = [permission.canView, permission.canCreate, permission.canEdit, permission.canDelete].filter(Boolean).length;
        const permissionIcon = permissionIcons[permission.resource as keyof typeof permissionIcons];
        const permissionName = resourceLabels[permission.resource] ?? permission.resource;
        const permissionCountMessage = activeCount === defaultEntityPermissions.length ? "All" : `${activeCount} of ${defaultEntityPermissions.length}`;
        return <div className="py-2.5 sm:py-1.75 pl-3 pr-2 flex flex-wrap gap-x-2 gap-y-3 items-center justify-between" key={permission.resource}><div className="flex items-center gap-2">{permissionIcon}<p className="font-medium text-sm capitalize">{permissionName}</p><p className="text-[11px] text-muted-foreground/80">{`(${permissionCountMessage} permissions)`}</p></div><ToggleGroup className={cn("rounded-lg shadow-none! min-w-full sm:min-w-fit", "[&_svg]:size-3! [&_svg]:hidden sm:[&_svg]:inline-block [&_button]:border-gray-300! [&_button]:flex-1 [&_button]:hover:bg-accent/10 [&_button]:hover:text-foreground", "[&_button]:px-2! sm:[&_button]:px-3! [&_button]:py-1! [&_button]:text-xs! [&_button]:font-normal! [&_button]:gap-1! [&_button]:h-7!", "[&_button]:data-[state=on]:bg-primary/10 [&_button]:data-[state=on]:text-primary")} onValueChange={value => {
            onPermissionChange(index, {
              ...permission,
              canCreate: value.includes("canCreate"),
              canDelete: value.includes("canDelete"),
              canEdit: value.includes("canEdit"),
              canView: value.includes("canView")
            });
          }} size="sm" type="multiple" value={[permission.canCreate ? "canCreate" : "", permission.canView ? "canView" : "", permission.canEdit ? "canEdit" : "", permission.canDelete ? "canDelete" : ""].filter(Boolean)} variant="outline"><ToggleGroupItem aria-label={`Create ${permission.resource}`} value="canCreate"><PlusCircle />Create</ToggleGroupItem><ToggleGroupItem aria-label={`View ${permission.resource}`} value="canView"><Eye />View</ToggleGroupItem><ToggleGroupItem aria-label={`Edit ${permission.resource}`} value="canEdit"><PenLine />Edit</ToggleGroupItem><ToggleGroupItem aria-label={`Delete ${permission.resource}`} value="canDelete"><Trash2 />Delete</ToggleGroupItem></ToggleGroup></div>;
      };
      $[4] = onPermissionChange;
      $[5] = resourceLabels;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = permissions.map(t3);
    $[0] = onPermissionChange;
    $[1] = permissions;
    $[2] = resourceLabels;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="w-full space-y-0 divide-y divide-gray-200 rounded-lg border border-gray-200">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export function PermissionsSection(t0) {
  const $ = _c(14);
  const {
    permissions,
    onPermissionChange,
    className: t1,
    defaultOpen: t2,
    id,
    resourceLabels
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const defaultOpen = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn(className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== defaultOpen) {
    t4 = defaultOpen && {
      defaultValue: "permissions"
    };
    $[2] = defaultOpen;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AccordionTrigger className="hover:no-underline pt-0 pb-2.5"><CardHeader className="px-0 pt-0 gap-0 w-full"><CardTitle className="text-sm">Permissions</CardTitle><CardDescription className="text-xs">Configure access levels for this user on each resource.</CardDescription></CardHeader></AccordionTrigger>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onPermissionChange || $[6] !== permissions || $[7] !== resourceLabels) {
    t6 = <AccordionItem value="permissions">{t5}<AccordionContent><PermissionControl onPermissionChange={onPermissionChange} permissions={permissions} resourceLabels={resourceLabels} /></AccordionContent></AccordionItem>;
    $[5] = onPermissionChange;
    $[6] = permissions;
    $[7] = resourceLabels;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== id || $[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <Accordion className={t3} collapsible={true} id={id} type="single" {...t4}>{t6}</Accordion>;
    $[9] = id;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}